module.exports = __webpack_public_path__ + "static/img/banner_4.9eda881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche/banner_4.jpg
// module id = moWD
// module chunks = 19